export const IFRAME_SYNCED_PREFIX = '@@iframe-synced/';
// Layout actions
export const DESELECT_ELEMENT = 'DESELECT_ELEMENT';

// Drag and drop
export const DRAG_LAYOUT_TILE = `${IFRAME_SYNCED_PREFIX}DRAG_LAYOUT_TILE`;
export const DRAG_ELEMENT_TILE = `${IFRAME_SYNCED_PREFIX}DRAG_ELEMENT_TILE`;
export const DRAG_ELEMENT = `${IFRAME_SYNCED_PREFIX}DRAG_ELEMENT`;
export const DRAG_SECTION = `${IFRAME_SYNCED_PREFIX}DRAG_SECTION`;
export const DRAG_SAVED_SECTION = `${IFRAME_SYNCED_PREFIX}DRAG_SAVED_SECTION`;
export const START_APP_DRAG = `${IFRAME_SYNCED_PREFIX}START_APP_DRAG`;
export const ENDED_APP_DRAG = `${IFRAME_SYNCED_PREFIX}ENDED_APP_DRAG`;

// API actions
export const OPEN_FILE_MANAGER = 'OPEN_FILE_MANAGER';
export const CLOSE_FILE_MANAGER = 'CLOSE_FILE_MANAGER';
export const UPDATE_PORTAL_RESOURCE = 'UPDATE_PORTAL_RESOURCE';
export const EDIT_PORTAL_RESOURCE = 'EDIT_PORTAL_RESOURCE';
export const ADD_PORTAL_RESOURCE = 'ADD_PORTAL_RESOURCE';
export const CREATED_PORTAL_RESOURCE = 'CREATED_PORTAL_RESOURCE';
export const SEARCH_PAGES = 'SEARCH_PAGES';
export const EDITOR_INITIALIZED = 'EDITOR_INITIALIZED';
export const OPEN_ECOMMERCE_CONNECT_PANEL = 'OPEN_ECOMMERCE_CONNECT_PANEL';

// File upload actions
export const UPLOAD_FILE = `${IFRAME_SYNCED_PREFIX}UPLOAD_FILE`;
export const FILE_UPLOAD_STARTED = `${IFRAME_SYNCED_PREFIX}FILE_UPLOAD_STARTED`;
export const FILE_UPLOAD_PRELOADED = `${IFRAME_SYNCED_PREFIX}FILE_UPLOAD_PRELOADED`;
export const FILE_UPLOAD_FAILURE = `${IFRAME_SYNCED_PREFIX}FILE_UPLOAD_FAILURE`;
export const FILE_UPLOAD_PROGRESS = `${IFRAME_SYNCED_PREFIX}FILE_UPLOAD_PROGRESS`;

// User interface
export const MOUSEOVER_SECTION = 'MOUSEOVER_SECTION';
export const MOUSELEAVE_SECTION = 'MOUSELEAVE_SECTION';
export const MOUSEOVER_ELEMENT = 'MOUSEOVER_ELEMENT';
export const MOUSELEAVE_ELEMENT = 'MOUSELEAVE_ELEMENT';
export const TOGGLE_FILE_MANAGER = 'TOGGLE_FILE_MANAGER';
export const SCROLL_CONTAINER = `${IFRAME_SYNCED_PREFIX}SCROLL_CONTAINER`;
export const MOUSEOVER_COMMENTABLE_AREA = 'MOUSEOVER_COMMENTABLE_AREA';
export const MOUSELEAVE_COMMENTABLE_AREA = 'MOUSELEAVE_COMMENTABLE_AREA';